import { render, staticRenderFns } from "./MethodBrowse.vue?vue&type=template&id=f4d8079a"
import script from "./MethodBrowse.vue?vue&type=script&lang=js"
export * from "./MethodBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports